import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bc1e3400"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "BlackWhiteDotAnimationContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "向上", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "向下", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "向左", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "向右", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12,
      class: _normalizeClass(`flex items-center border pd18 ${$data.active == 0 ? 'active' : ''}`)
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }, 8, ["class"]), _createVNode(_component_el_col, {
      span: 12,
      class: _normalizeClass(`flex justify-end items-center border pd18 ${$data.active == 1 ? 'active' : ''}`)
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }, 8, ["class"])]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12,
      class: _normalizeClass(`flex items-center border pd18 ${$data.active == 2 ? 'active' : ''}`)
    }, {
      default: _withCtx(() => [_hoisted_4]),
      _: 1
    }, 8, ["class"]), _createVNode(_component_el_col, {
      span: 12,
      class: _normalizeClass(`flex justify-end items-center border pd18 ${$data.active == 3 ? 'active' : ''}`)
    }, {
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    }, 8, ["class"])]),
    _: 1
  })]);
}